import { Injectable } from '@angular/core';

@Injectable()
export class GuidValidatorService {

    public isGuid(possibleGuid:any):boolean{
        return /^\{?[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\}?$/.test(possibleGuid);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/validation/guid-validator.service.ts